var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BasisLoader } from '@pixi/basis';
import { extname } from 'path';
import { ALPHA_MODES, BaseTexture, MIPMAP_MODES, Texture } from 'pixi.js';
const registerTexture = (url, resource) => {
    let texture;
    try {
        const base = new BaseTexture(resource, {
            mipmap: MIPMAP_MODES.OFF,
            alphaMode: ALPHA_MODES.NO_PREMULTIPLIED_ALPHA,
        });
        texture = new Texture(base);
        BaseTexture.addToCache(base, url);
        Texture.addToCache(texture, url);
    }
    catch (e) {
        console.log(e);
    }
    return texture;
};
const loadBasis = {
    test(url) {
        return (extname(url).includes('.basis'));
    },
    load(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield (yield fetch(url)).arrayBuffer();
            const resources = yield BasisLoader['transcodeAsync'](data);
            return registerTexture(url, resources[0]);
        });
    },
};
export { loadBasis };
